/**
 * Static fake data lists for PII obfuscation.
 * Used by ObfuscationService for deterministic name mapping via DJB2 hash.
 * Mix of common English, Maori, and Pacific Islander names for NZ context.
 *
 * ~500 first names x ~500 last names = ~250,000 unique full name combinations
 * to minimise duplicate collisions when hashing real patient names.
 */

export const FAKE_FIRST_NAMES: string[] = [
  // Common English — Male
  'James',
  'Liam',
  'Noah',
  'Ethan',
  'Mason',
  'William',
  'Lucas',
  'Henry',
  'Jack',
  'Oliver',
  'Leo',
  'Benjamin',
  'Alexander',
  'Daniel',
  'Samuel',
  'Sebastian',
  'Mateo',
  'Owen',
  'Theodore',
  'Aiden',
  'Caleb',
  'Ryan',
  'Nathan',
  'Adrian',
  'Reuben',
  'Felix',
  'Oscar',
  'Hugo',
  'Archie',
  'Max',
  'Charlie',
  'Thomas',
  'George',
  'Finn',
  'Harrison',
  'Jake',
  'Elijah',
  'Joshua',
  'Connor',
  'Dylan',
  'Hunter',
  'Cooper',
  'Blake',
  'Tyler',
  'Lincoln',
  'Lachlan',
  'Patrick',
  'Callum',
  'Carter',
  'Jayden',
  'Xavier',
  'Mitchell',
  'Angus',
  'Marcus',
  'Cameron',
  'Declan',
  'Jesse',
  'Toby',
  'Hamish',
  'Fraser',
  'Louis',
  'Edward',
  'Miles',
  'Asher',
  'Jaxon',
  'Elliot',
  'Bodhi',
  'Cruz',
  'Roman',
  'Rowan',
  'River',
  'Phoenix',
  'Kingston',
  'Legend',
  'Atlas',
  'Zane',
  'Knox',
  'Orion',
  'Micah',
  'Noel',
  'Reid',
  'Calvin',
  'Maxwell',
  'Spencer',
  'Brody',
  'Dominic',
  'Vincent',
  'Grant',
  'Wesley',
  'Nolan',
  'Cole',
  'Everett',
  'Beckett',
  'Austin',
  'Zachary',
  'Parker',
  'Sawyer',
  'Weston',
  'Jason',
  'Aaron',
  'Derek',
  'Colin',
  'Travis',
  'Preston',
  'Russell',
  'Shane',
  'Darren',
  'Craig',
  'Glen',
  'Trevor',
  'Lance',
  'Kent',
  'Damian',
  'Troy',
  'Brendan',
  'Gavin',
  'Ivan',
  'Corey',
  'Dennis',
  'Neil',
  'Brent',
  'Keith',
  'Clint',
  'Scott',
  'Brett',
  'Alec',
  'Bruce',
  'Graham',
  'Clinton',
  'Dean',
  'Geoffrey',
  'Nigel',
  'Gareth',
  'Kelvin',
  'Lloyd',
  'Murray',
  'Warren',
  'Stuart',
  'Gordon',
  'Malcolm',
  'Rodney',
  'Vernon',
  'Clifford',
  'Lawrence',
  'Bernard',
  'Terence',
  'Gerald',
  'Raymond',
  'Phillip',
  'Leonard',
  'Wallace',
  'Arnold',
  'Desmond',
  'Stanley',
  'Reginald',
  'Cedric',
  'Rupert',

  // Common English — Female
  'Emma',
  'Olivia',
  'Ava',
  'Mia',
  'Sophie',
  'Isabella',
  'Charlotte',
  'Amelia',
  'Harper',
  'Ella',
  'Grace',
  'Chloe',
  'Zoe',
  'Lily',
  'Aria',
  'Riley',
  'Layla',
  'Penelope',
  'Nora',
  'Hazel',
  'Aurora',
  'Savannah',
  'Brooklyn',
  'Bella',
  'Freya',
  'Ivy',
  'Ruby',
  'Stella',
  'Luna',
  'Willow',
  'Violet',
  'Scarlett',
  'Maya',
  'Isla',
  'Poppy',
  'Daisy',
  'Alice',
  'Evelyn',
  'Hannah',
  'Leah',
  'Sarah',
  'Abigail',
  'Emily',
  'Phoebe',
  'Madeline',
  'Audrey',
  'Clara',
  'Rose',
  'Eva',
  'Naomi',
  'Ellie',
  'Lucy',
  'Jade',
  'Amber',
  'Holly',
  'Sienna',
  'Paige',
  'Brooke',
  'Samantha',
  'Rachel',
  'Lauren',
  'Jasmine',
  'Natalie',
  'Gabriella',
  'Mackenzie',
  'Aaliyah',
  'Quinn',
  'Taylor',
  'Peyton',
  'Kennedy',
  'Addison',
  'Skylar',
  'Autumn',
  'Genesis',
  'Serenity',
  'Nova',
  'Elise',
  'Ariana',
  'Valentina',
  'Emilia',
  'Lydia',
  'Piper',
  'Victoria',
  'Nicole',
  'Melissa',
  'Jessica',
  'Rebecca',
  'Amanda',
  'Stephanie',
  'Megan',
  'Courtney',
  'Heather',
  'Vanessa',
  'Andrea',
  'Christina',
  'Alexandra',
  'Diana',
  'Felicity',
  'Bridget',
  'Dorothy',
  'Frances',
  'Madeleine',
  'Catherine',
  'Margaret',
  'Elizabeth',
  'Helen',
  'Josephine',
  'Vivienne',
  'Annabel',
  'Matilda',
  'Harriet',
  'Beatrice',
  'Florence',
  'Genevieve',
  'Adelaide',
  'Clementine',
  'Rosalind',
  'Cordelia',
  'Winifred',
  'Millicent',
  'Imogen',
  'Gwendolyn',
  'Penrose',
  'Celeste',
  'Miriam',
  'Estelle',
  'Odette',
  'Colette',
  'Camille',
  'Eloise',
  'Margot',
  'Delphine',
  'Simone',
  'Thea',
  'Daphne',
  'Greta',
  'Vera',
  'Iris',
  'Pearl',
  'June',
  'April',
  'Dawn',
  'Fern',
  'Wren',
  'Sage',
  'Lake',
  'Blair',
  'Skye',
  'Eden',
  'Sloane',
  'Harlow',
  'Marlowe',

  // Maori
  'Aroha',
  'Nikau',
  'Tane',
  'Manaia',
  'Kahu',
  'Maia',
  'Ariki',
  'Anahera',
  'Rawiri',
  'Mere',
  'Wiremu',
  'Hine',
  'Rua',
  'Kaia',
  'Tamati',
  'Whina',
  'Ihaia',
  'Marama',
  'Ari',
  'Tia',
  'Kai',
  'Ataahua',
  'Eruera',
  'Hinemoa',
  'Inia',
  'Kapua',
  'Koha',
  'Kotiro',
  'Maata',
  'Mihi',
  'Ngaio',
  'Pania',
  'Pare',
  'Rangi',
  'Ria',
  'Rongo',
  'Tama',
  'Tui',
  'Waiata',
  'Wairua',
  'Whetu',
  'Amokura',
  'Hinewai',
  'Kahurangi',
  'Manawanui',
  'Puawai',
  'Taika',
  'Tipene',
  'Hemi',
  'Hoani',
  'Petera',
  'Paora',
  'Rewi',
  'Haki',
  'Kiri',
  'Maui',
  'Piripi',
  'Tahu',
  'Tiaki',
  'Waka',
  'Erana',
  'Huia',
  'Kuini',
  'Mokoia',
  'Ngaire',
  'Rata',
  'Ripeka',
  'Waiariki',

  // Pacific Islander
  'Sione',
  'Ana',
  'Manu',
  'Leilani',
  'Sina',
  'Kalani',
  'Moana',
  'Koa',
  'Mele',
  'Ioane',
  'Lani',
  'Pita',
  'Talia',
  'Keanu',
  'Anika',
  'Tapu',
  'Malia',
  'Aleki',
  'Eseta',
  'Fetu',
  'Heilala',
  'Iosefa',
  'Losa',
  'Mele',
  'Ofisa',
  'Paulo',
  'Selu',
  'Talita',
  'Tavita',
  'Uili',
  'Vaha',
  'Alisi',
  'Falaniko',
  'Koloa',
  'Makelesi',
  'Niko',
  'Petelo',
  'Simone',
  'Telani',
  'Ula',
  'Vaiola',
  'Siaki',
  'Falakika',
  'Lesieli',
  'Mateaki',
  'Tupou',
  'Keoni',
  'Makana',
  'Nalani',
  'Palani',
  'Kaimana',
  'Maile',
  'Noelani',
  'Kaleo',
  'Alani',
  'Haukea',
  'Ikaika',
  'Kainoa',
  'Mahina',
  'Naia',
  'Pualani',

  // South Asian / East Asian (common in NZ)
  'Arun',
  'Priya',
  'Raj',
  'Anita',
  'Deepak',
  'Kavita',
  'Vikram',
  'Sunita',
  'Arjun',
  'Meera',
  'Ravi',
  'Nisha',
  'Min',
  'Yuki',
  'Hiro',
  'Mei',
  'Jun',
  'Lin',
  'Wei',
  'Chen',
];

export const FAKE_LAST_NAMES: string[] = [
  // Common English/European
  'Smith',
  'Johnson',
  'Williams',
  'Brown',
  'Wilson',
  'Taylor',
  'Patel',
  'Anderson',
  'Thomas',
  'Jackson',
  'White',
  'Harris',
  'Martin',
  'Thompson',
  'Garcia',
  'Martinez',
  'Robinson',
  'Clark',
  'Rodriguez',
  'Lewis',
  'Lee',
  'Walker',
  'Hall',
  'Allen',
  'Young',
  'King',
  'Wright',
  'Scott',
  'Green',
  'Baker',
  'Adams',
  'Nelson',
  'Hill',
  'Mitchell',
  'Roberts',
  'Campbell',
  'Carter',
  'Phillips',
  'Evans',
  'Turner',
  'Torres',
  'Parker',
  'Collins',
  'Edwards',
  'Stewart',
  'Flores',
  'Morris',
  'Nguyen',
  'Murphy',
  'Rivera',
  'Bennett',
  'Cook',
  'Cooper',
  'Davies',
  'Hughes',
  'Kelly',
  'Marshall',
  'Mason',
  'Murray',
  'Palmer',
  'Price',
  'Reid',
  'Ross',
  'Shaw',
  'Simpson',
  'Stevens',
  'Sullivan',
  'Ward',
  'Watson',
  'Webb',
  'Wells',
  'Wood',
  'Crawford',
  'Cunningham',
  'Davidson',
  'Dixon',
  'Duncan',
  'Elliott',
  'Ferguson',
  'Fisher',
  'Fleming',
  'Fletcher',
  'Gordon',
  'Graham',
  'Grant',
  'Gray',
  'Hamilton',
  'Harper',
  'Hayes',
  'Henderson',
  'Holmes',
  'Hunt',
  'Hunter',
  'Jenkins',
  'Johnston',
  'Kennedy',
  'Lambert',
  'Lane',
  'Lawrence',
  'Lloyd',
  'Logan',
  'Mackenzie',
  'Manning',
  'Marsh',
  'Maxwell',
  'McDonald',
  'Morrison',
  'Newton',
  'Oliver',
  'Owen',
  'Page',
  'Pearson',
  'Porter',
  'Powell',
  'Ramsay',
  'Reynolds',
  'Richardson',
  'Rogers',
  'Russell',
  'Sanders',
  'Sharp',
  'Shepherd',
  'Spencer',
  'Stone',
  'Thomson',
  'Todd',
  'Tucker',
  'Valentine',
  'Vincent',
  'Wallace',
  'Warren',
  'Webster',
  'Wheeler',
  'Willis',
  'York',
  'Armstrong',
  'Bailey',
  'Barker',
  'Barnes',
  'Bell',
  'Bishop',
  'Bolton',
  'Booth',
  'Brady',
  'Brennan',
  'Burke',
  'Burns',
  'Burton',
  'Byrne',
  'Carroll',
  'Chapman',
  'Clarke',
  'Cole',
  'Connolly',
  'Craig',
  'Cross',
  'Doyle',
  'Dunn',
  'Ellis',
  'Ford',
  'Fox',
  'Frost',
  'Gibson',
  'Holland',
  'Howard',
  'Atkinson',
  'Barlow',
  'Bates',
  'Blake',
  'Bond',
  'Bridges',
  'Briggs',
  'Buckley',
  'Chambers',
  'Chandler',
  'Clayton',
  'Clifton',
  'Coleman',
  'Coles',
  'Cooke',
  'Copeland',
  'Dalton',
  'Dawson',
  'Drake',
  'Drummond',
  'Easton',
  'Edmonds',
  'Emerson',
  'Farrell',
  'Finch',
  'Forrest',
  'Gallagher',
  'Garrett',
  'Goodwin',
  'Gould',
  'Griffiths',
  'Hale',
  'Hancock',
  'Harrington',
  'Hartley',
  'Hastings',
  'Hawkins',
  'Hayward',
  'Heath',
  'Holt',
  'Horton',
  'Howell',
  'Hutchinson',
  'Irving',
  'James',
  'Jennings',
  'Joyce',
  'Kane',
  'Kemp',
  'Kerr',
  'Kingsford',
  'Kirby',
  'Knight',
  'Lamb',
  'Lawson',
  'Leach',
  'Lindsay',
  'Lowe',
  'Lynch',
  'Maguire',
  'Malone',
  'Mansfield',
  'Mead',
  'Mercer',
  'Milne',
  'Montague',
  'Moody',
  'Moore',
  'Moss',
  'Mulligan',
  'Nash',
  'Neville',
  'Norris',
  'Oakley',
  'Osborne',
  'Parry',
  'Paxton',
  'Pearce',
  'Pemberton',
  'Perry',
  'Plummer',
  'Quinn',
  'Randall',
  'Reeves',
  'Ridley',
  'Riley',
  'Robson',
  'Rowley',
  'Rutherford',
  'Saunders',
  'Sawyer',
  'Sheldon',
  'Sinclair',
  'Slater',
  'Stafford',
  'Stanton',
  'Steele',
  'Stokes',
  'Sutton',
  'Thornton',
  'Townsend',
  'Trotter',
  'Underwood',
  'Vaughan',
  'Wade',
  'Wakefield',
  'Walters',
  'Whitaker',
  'Whitfield',
  'Williamson',
  'Winter',
  'Woodward',
  'Yates',

  // Maori
  'Te Whare',
  'Tamati',
  'Nikora',
  'Henare',
  'Pomare',
  'Ngata',
  'Hohepa',
  'Kauri',
  'Rapata',
  'Eruera',
  'Wiremu',
  'Tainui',
  'Makoare',
  'Te Puni',
  'Te Rauparaha',
  'Parata',
  'Kohere',
  'Rangi',
  'Pene',
  'Tuhoe',
  'Rewi',
  'Potaka',
  'Karaka',
  'Tawhiri',
  'Tipene',
  'Waaka',
  'Paki',
  'Heke',
  'Te Aho',
  'Turei',
  'Katene',
  'Pewhairangi',
  'Kaa',
  'Te Kanawa',
  'Waititi',
  'Matangi',
  'Manu',
  'Harawira',
  'Mahuta',
  'Tohu',
  'Tapsell',
  'Herewini',
  'Ngatai',
  'Te Huia',
  'Takurua',
  'Whaanga',
  'Parekura',
  'Turia',
  'Pere',
  'Kereopa',

  // Tongan / Samoan / Pacific Islander
  'Taufa',
  'Tupou',
  'Fakaosilea',
  'Latu',
  'Taumoepeau',
  'Tuipulotu',
  'Havili',
  'Fifita',
  'Mafi',
  'Folau',
  'Savea',
  'Ioane',
  'Lam',
  'Tuilagi',
  'Nonu',
  'Ahki',
  'Aumua',
  'Falekaono',
  'Finau',
  'Fonua',
  'Hausia',
  'Ikavalu',
  'Katoa',
  'Katonivere',
  'Koloamatangi',
  'Lauaki',
  'Luatua',
  'Maafu',
  'Manase',
  'Matavao',
  'Moala',
  'Moimoi',
  'Niubalavu',
  'Palepoi',
  'Piutau',
  'Polota',
  'Sekope',
  'Seuteni',
  'Taione',
  'Talakai',
  'Taumalolo',
  'Tuivaiti',
  'Vaega',
  'Vaenuku',
  'Vunipola',
  'Apisai',
  'Faaoso',
  'Lauese',
  'Malakai',
  'Talamaivao',
  'Ulugia',

  // South Asian (common in NZ)
  'Sharma',
  'Singh',
  'Kumar',
  'Gupta',
  'Reddy',
  'Kapoor',
  'Desai',
  'Mehta',
  'Shah',
  'Chandra',
  'Rao',
  'Nair',

  // East Asian (common in NZ)
  'Wong',
  'Chen',
  'Zhang',
  'Li',
  'Wang',
  'Kim',
  'Park',
  'Tanaka',
  'Suzuki',
  'Yamamoto',
  'Watanabe',
  'Nakamura',
];

export const FAKE_EMAIL_DOMAINS: string[] = [
  'example.com',
  'test.org',
  'demo.net',
  'sample.co.nz',
  'mailtest.com',
  'inbox.test',
  'testmail.org',
  'email.example',
  'fakemail.co.nz',
  'postbox.test',
  'letters.example',
  'maildrop.org',
  'webmail.test',
  'quickmail.example',
  'fastmail.test',
  'sendbox.org',
  'mailhub.test',
  'notemail.example',
  'clearmail.org',
  'simplemail.test',
  'openmail.example',
  'greenmail.org',
  'bluemail.test',
  'starmail.example',
  'cloudmail.org',
  'skymail.test',
  'oceanmail.example',
  'ridgemail.org',
  'peakmail.test',
  'valleymail.example',
  'brookmail.org',
  'fieldmail.test',
  'stonemail.example',
  'hillmail.org',
  'lakemail.test',
  'baymail.example',
  'covemail.org',
  'dalemail.test',
  'glenmail.example',
  'meadowmail.org',
  'plainmail.test',
  'creekmail.example',
  'grovemail.org',
  'woodmail.test',
  'fernmail.example',
  'mossmail.org',
  'ashmail.test',
  'elmmail.example',
  'oakmail.org',
  'pinemail.test',
];

export const FAKE_STREET_NAMES: string[] = [
  'Main Street',
  'Oak Avenue',
  'Elm Drive',
  'Maple Road',
  'Cedar Lane',
  'Pine Crescent',
  'Birch Way',
  'Willow Place',
  'Kauri Road',
  'Rimu Street',
  'Totara Avenue',
  'Pohutukawa Drive',
  'Kowhai Lane',
  'Manuka Crescent',
  'Rata Way',
  'Nikau Place',
  'Tui Road',
  'Kiwi Street',
  'Bellbird Avenue',
  'Fantail Drive',
  'Harbour View Road',
  'Ocean Parade',
  'Beach Road',
  'Mountain View Drive',
  'Valley Road',
  'River Terrace',
  'Lake Crescent',
  'Park Avenue',
  'Station Road',
  'Church Street',
];

export const FAKE_SUBURBS: string[] = [
  'Greenfield',
  'Riverside',
  'Oakwood',
  'Hillcrest',
  'Meadowlands',
  'Fairview',
  'Brookside',
  'Sunnyside',
  'Lakeview',
  'Parklands',
  'Westbrook',
  'Northgate',
  'Eastwood',
  'Southridge',
  'Bayview',
  'Seaside',
  'Mountain View',
  'Valley Heights',
  'Woodland',
  'Clearwater',
];
